export enum FractionTested {
  Sizes4mmTo31_5mm = 'Sizes4mmTo31_5mm',
  Sizes31_5mmTo63mm = 'Sizes31_5mmTo63mm',
}

export enum UpperAggregateSievesize {
  Sieve63_0mm = '63_0',
  Sieve56_0mm = '56_0',
  Sieve53_0mm = '53_0',
  Sieve50_0mm = '50_0',
  Sieve45_0mm = '45_0',
}

export enum OversizeParticlesTreatment {
  NoOversize = 'NoOversize',
  OversizeParticlesReduced = 'OversizeParticlesReduced',
  OversizeParticlesDiscarded = 'OversizeParticlesDiscarded',
}

export const FractionTestedOptions = [
  { label: '4 mm to 31.5 mm', value: FractionTested.Sizes4mmTo31_5mm },
  { label: '31.5 mm to 63 mm', value: FractionTested.Sizes31_5mmTo63mm },
];
